import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IStampsOffer } from '@/shared/model/stamps-offer.model';

const baseApiUrl = 'api/stamps-offers';
const baseSearchApiUrl = 'api/_search/stamps-offers?query=';
const baseLocationApiUrl = 'api/merchant-locations/merchantId';

export default class StampsOfferService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IStampsOffer> {
    return new Promise<IStampsOffer>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IStampsOffer): Promise<IStampsOffer> {
    return new Promise<IStampsOffer>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IStampsOffer): Promise<IStampsOffer> {
    return new Promise<IStampsOffer>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieveMerchantLocations(id: number, paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseLocationApiUrl}/${id}?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
